import { useAuth0 } from '@auth0/auth0-react'
import { jwtDecode, JwtPayload } from 'jwt-decode'
import { useEffect, useState } from 'react'

export enum NextGenClaims {
  Roles = 'http://tendo.com/roles',
}

type TokenWithNextGenClaims = JwtPayload & {
  [key in NextGenClaims]: string | string[]
}

/**
 * Similar to how to the tcc API works, any existence of a role will allow for Admin access at this time
 * @returns isAdmin result
 */
export const useIsAdmin = () => {
  const [isAdmin, setIsAdmin] = useState(false)
  const { getAccessTokenSilently } = useAuth0()

  useEffect(() => {
    const checkIsAdmin = async () => {
      const accessToken = await getAccessTokenSilently()
      const decodedToken = jwtDecode(accessToken) as TokenWithNextGenClaims
      const roles = decodedToken[NextGenClaims.Roles] as string[]
      if (!roles || roles.length === 0) {
        setIsAdmin(false)
      } else {
        setIsAdmin(true)
      }
    }

    checkIsAdmin()
  }, [getAccessTokenSilently])

  return isAdmin
}
